<template>
  <div
    class="mx-auto"
    v-if="translations !== undefined"
  >
    <v-row class="homepage__header">
      <v-col cols="4" class="px-0 py-0">
        <v-img  alt="" cover class="home__logo" src="@/assets/redcar/logo.png" data-cypress-value="logo"/>
      </v-col>
      <v-col cols="8">
        <h2 class="home__headline-text black--text" data-cypress-value="headline"> Target </h2>
        <v-img  alt="" contain class="arrow" src="@/assets/redcar/arrow.png"/>
        <p v-html="translations.home.subtitle" class="home__strapline-text" data-cypress-value="strapline" id="homepage-header"> </p>
      </v-col>
    </v-row>

    <v-tour name="myTour" :steps="steps" :options="configuration" :callbacks="myCallbacks"></v-tour>

    <v-container no-gutters class="home__block-wrapper">
      <router-link
        :to="{ name: 'infoandadvice'}"
        class="homepage__list-item"
        ripple
        data-cypress-value="info-block"
        id="infoandadviceblock"
      >
        <v-card ripple class="">
          <v-card-title class="">{{translations.home.labels.info}}</v-card-title>
        </v-card>
      </router-link>

      <router-link
        :to="{ name: 'events'}"
        class="homepage__list-item"
        ripple
        data-cypress-value="events-block"
        id="eventsblock"
      >
        <v-card class="" ripple>
          <v-card-title>{{translations.home.labels.events}}</v-card-title>
        </v-card>
      </router-link>

      <router-link
        :to="{ name: 'organisations'}"
        class="homepage__list-item"
        ripple
        data-cypress-value="orgs-block"
        id="organisationsblock"
      >
        <v-card class="" ripple>
          <v-card-title>{{translations.home.labels.providers}}</v-card-title>
        </v-card>
      </router-link>

      <router-link
        :to="{ name: 'opportunities'}"
        class="homepage__list-item"
        ripple
        data-cypress-value="apprenticeships-block"
        id="apprenticeshipsblock"
      >
        <v-card class="" ripple>
          <v-card-title>{{translations.home.labels.apprenticeships}}</v-card-title>
        </v-card>
      </router-link>

      <router-link
        :to="{ name: 'favourites'}"
        class="homepage__list-item"
        ripple
        data-cypress-value="favourites-block"
        id="favouritesblock"
      >
        <v-card class="" ripple>
          <v-card-title>{{translations.home.labels.favourites}}</v-card-title>
        </v-card>
      </router-link>

      <router-link
        :to="{ name: 'vips'}"
        class="homepage__list-item"
        ripple
        data-cypress-value="vips-block"
        id="vipsblock"
      >
        <v-card class="" ripple>
          <v-card-title>{{translations.home.labels.vips}}</v-card-title>
        </v-card>
      </router-link>
    </v-container>

    <v-container class="download-the-app" v-if="isMobile && is_using_a_browser">
      <v-row>
        <v-img  alt="" cover style="width: 40px; height:40px; margin-right: 10px" src="@/assets/redcar/logo.png" data-cypress-value="logo"/>
        <p>{{translations.home.labels.stores }}</p>
      </v-row>

      <v-row class="download-the-app__icons">
        <v-col cols="4">
          <a href="https://play.google.com/store/apps/details?id=uk.co.thisisfocus.claredcar" target="_blank">
            <v-img contain src="@/assets/redcar/google-play.png/" alt="google play"></v-img>
          </a>
        </v-col>
        <v-col cols="4">
          <a href="https://apps.apple.com/us/app/target-care-leavers-app/id1615062512" target="_blank">
            <v-img contain src="@/assets/redcar/apple-store.png/" alt="apple store"></v-img>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";
import router from '../router/index.js'

export default {
  data() {
    return {
      configuration: {
        labels: {
          buttonSkip: '',
          buttonPrevious: '',
          buttonNext: '',
          buttonStop: ''
        }
      },
      myCallbacks: {
        onStart: this.recordStartOfTour,
        onSkip: this.recordSkippedStep,
        onFinish: this.recordFinishingTour
      },
      /// steps set here are using translations via setTranslationsForTutorial()
      steps: [
        {
          target: '#homepage-header',
          header: {
            title: ''
          },
          content: '',
          params: {
            placement: 'top'
          }
        },
        {
          target: '#infoandadviceblock',
          header: {
            title: '',
          },
          content: '',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '#eventsblock',
          header: {
            title: '',
          },
          content: '',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '#organisationsblock',
          header: {
            title: '',
          },
          content: '',
          params: {
            placement: 'top'
          }
        },
        {
          target: '#apprenticeshipsblock',
          header: {
            title: '',
          },
          content: '',
          params: {
            placement: 'top'
          }
        },
        {
          target: '#vipsblock',
          header: {
            title: '',
          },
          content: '',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '#favouritesblock',
          header: {
            title: '',
          },
          content: '',
          params: {
            placement: 'top'
          }
        },
        {
          target: '#menublock',
          header: {
            title: '',
          },
          content: '',
          params: {
            placement: 'bottom'
          }
        },
      ],
    }
  },
  computed: {
    hubbdata() {
      return hubbdata.getters.data;
    },
    cms_pages() {
      return hubbdata.state.cms_pages;
    },
    root_cms_pages() {
      return hubbdata.getters.rootCmsPages;
    },
    translations() {
      return hubbdata.getters.translations;
    },
    rootcategories() {
      return hubbdata.getters.getRootCategories
    },
    userHasSeenTheTour() {
      return localStorage.getItem('has_seen_the_tour') !== null
    },
    is_using_a_browser() {
      if (window.cordova) {
        return false
      } else {
        return true
      }
    },
    isMobile() {
      return(window.screen.width < 768);
    }
  },
  methods: {
    recordStartOfTour() {
      ga('send', 'pageview', 'started tutorial'); // eslint-disable-line
    },
    recordSkippedStep() {
      ga('send', 'pageview', 'skipped tutorial'); // eslint-disable-line
      // record user has seen the tour
      localStorage.setItem('has_seen_the_tour', true)
    },
    recordFinishingTour() {
      ga('send', 'pageview', 'finished tutorial'); // eslint-disable-line
      // record user has seen the tour
      localStorage.setItem('has_seen_the_tour', true)
    },
    startTheAppTour() {
      if(!this.userHasSeenTheTour) {
        this.$tours['myTour'].start()
      }
    },
    setTranslationsForTutorial() {
      //getting started
      this.steps[0].header.title = this.translations.tutorial.title;
      this.steps[0].content = this.translations.tutorial.title_content;

      // info and advice
      this.steps[1].header.title = this.translations.tutorial.slides.info.title;
      this.steps[1].content = this.translations.tutorial.slides.info.text;

      // events
      this.steps[2].header.title =  this.translations.tutorial.slides.events.title;
      this.steps[2].content = this.translations.tutorial.slides.events.text;

      // organisations
      this.steps[3].header.title =  this.translations.tutorial.slides.services.title;
      this.steps[3].content = this.translations.tutorial.slides.services.text;

      // apprenticeships
      this.steps[4].header.title =  this.translations.tutorial.slides.apprenticeships.title;
      this.steps[4].content = this.translations.tutorial.slides.apprenticeships.text

      // vips
      this.steps[5].header.title =  this.translations.tutorial.slides.vips.title;
      this.steps[5].content = this.translations.tutorial.slides.vips.text;

      // favourites
      this.steps[6].header.title =  this.translations.tutorial.slides.favourites.title;
      this.steps[6].content = this.translations.tutorial.slides.favourites.text;

      //menu
      this.steps[7].header.title =  this.translations.tutorial.slides.menu.title;
      this.steps[7].content = this.translations.tutorial.slides.menu.text;
    },
    getTourButtonsTranslations() {
      this.configuration.labels.buttonSkip = this.translations.tutorial.slides.buttons.skip;
      this.configuration.labels.buttonPrevious = this.translations.tutorial.slides.buttons.back;
      this.configuration.labels.buttonNext = this.translations.tutorial.slides.buttons.next;
      this.configuration.labels.buttonStop = this.translations.tutorial.slides.buttons.ready;
    }
  },
  created() {
    if (localStorage.getItem('terms_accepted') === null) {
      router.push("/welcome")
    }
  },
  mounted: function() {
    ga('set', 'title', 'Home'); // eslint-disable-line
    ga('send', 'pageview', location.href); // eslint-disable-line

    hubbdata.dispatch("initDB");

    this.setTranslationsForTutorial();
    this.getTourButtonsTranslations();

    // starts vue tour plugin (v-tour component)
    this.startTheAppTour();
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  animation: fadeInAnimation ease 3s;
  opacity: 1;
}

@keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.homepage__list-item {
  width: 100%!important;

  @media screen and (min-width: 960px) {
    width: 49%!important;
  }

  .v-card {
    width: 100%!important;
  }
}

.home {

  &__strapline-text {
    text-align: left;
    font-size: 14px;
    font-weight:500!important;
    font-family:'muli', sans-serif!important;

    @media(max-width:300px) {
      font-size: 12px;
    }
  }

  @media screen and (min-width: 960px) {
    &__strapline-text {
      font-size: 16px;
    }
  }

  &__headline-text {
    color: black!important;
    text-align: right;
    font-size: 30px;
    line-height: 30px;
    font-weight:900!important;
    font-family:'muli', sans-serif!important;
    margin-right: 25px;
    @media (max-width: 350px) {
      font-size: 25px;
      line-height: 25px;
    }
  }

  &__logo {
    margin: 10px !important;
    margin-right: auto;
    margin-left: auto;
    @media(min-width: 600) {
      margin: 5px;
    }
  }
}

.v-card__title {
  color: white;
  font-weight:900!important;
  display: inline-block;
  word-break: initial;
  font-size:22px;
  line-height: 1.2em;
  font-family:'muli', sans-serif!important;

  @media (max-width: 360px) {
    font-size: 16px;
    padding-bottom: 0px;
  }
}

.home__block-wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-width: 420px;
  margin: 0 auto;
  margin-top: 40px;
  padding: 10px;

  @media screen and (min-width: 960px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 750px;
  }
}

.v-card {
  box-shadow: none!important;
  width: 100%;
  border-radius: 25px;
}

.v-card__title{
  width:100%;
}

#infoandadviceblock  {
  height: 150px;

  @media (max-width: 330px) {
    height: 150px;
  }

  @media screen and (min-width: 960px) {
    height: 170px;
  }

  .v-card {
    background-image: url('../assets/redcar/homepage/btn-info-and-advice.png');
    background-size: cover;
    background-position: center;
    height: 150px;

    @media (max-width: 330px) {
      height: 150px;
    }

    @media screen and (min-width: 960px) {
      height: 170px;
    }
  }

  .v-card__title {
    position: absolute;
    bottom: 0;
    text-transform: lowercase;
    font-weight: 900!important;
    font-family: 'muli', sans-serif!important;
    padding-bottom: 10px;
    max-width: 150px;
  }
}

#eventsblock {
  height: 190px;

  @media (max-width: 330px) {
    height: 150px;
  }

  .v-card  {
    background-image: url('../assets/redcar/homepage/btn-whats-on.png');
    background-size: cover;
    background-position: center;
    height: 190px;

    @media (max-width: 330px) {
      height: 150px;
    }

    @media screen and (min-width: 960px) {
      height: 220px;
    }
  }

  .v-card__title {
    text-transform: lowercase;
    font-weight: 900!important;
    font-family: 'muli', sans-serif!important;
    padding-top: 10px;
  }
}

#organisationsblock {
  @media screen and (min-width: 960px) {
    height: 150px;
    bottom: 17px;
  }
}

#organisationsblock .v-card {
  background-image: url('../assets/redcar/homepage/btn-who-can-help.png');
  background-size: cover;
  background-position: 50% 70%;
  height: 130px;
  position: relative;

  @media (max-width: 330px) {
    height: 130px;
    bottom: -5px
  }

  @media screen and (min-width: 960px) {
    height: 150px;
    bottom: 17px;
  }

  .v-card__title {
    position: absolute;
    right: 0;
    bottom: 0;
    text-transform: lowercase;
    font-weight:900!important;
    font-family:'muli', sans-serif!important;
    padding-bottom: 10px;
    text-align: right;
  }
}

#apprenticeshipsblock {
  @media screen and (min-width: 960px) {
    height: 150px;
    margin-top: 34px;
  }
}

#apprenticeshipsblock .v-card {
  background-image: url('../assets/redcar/homepage/btn-employment.png');
  background-size: cover;
  background-position: 50% 30%;
  height: 150px;

  .v-card__title {
    text-transform: lowercase;
    font-weight: 900!important;
    font-family: 'muli', sans-serif!important;
    text-align: right;
    color: black;
    padding-top: 5px;
    padding-right: 10px;
  }
}

#favouritesblock {
  @media screen and (min-width: 960px) {
    position: relative;
    height: 180px;
    bottom: 48px;
  }
}

#favouritesblock .v-card  {
  background-image: url('../assets/redcar/homepage/btn-favourites.png');
  background-size: cover;
  background-position: center;
  height: 150px;
  position: relative;

  @media (max-width: 330px) {
    height: 130px;
    bottom: 15px;
  }

  @media screen and (min-width: 960px) {
    height: 180px;
    bottom: 0px;
  }

  .v-card__title {
    position: absolute;
    bottom: 0;
    text-transform: lowercase;
    font-weight:900!important;
    font-family:'muli', sans-serif!important;
    padding-bottom: 10px;
    max-width: 150px;
  }
}

#vipsblock {
  @media screen and (min-width: 960px) {
    height: 130px;
  }
}

#vipsblock .v-card  {
  background-image: url('../assets/redcar/homepage/btn-vips.png');
  background-size: cover;
  background-position: center;
  height: 100px;

  @media (max-width: 330px) {
    height: 110px;
  }

  @media (max-width: 300px) {
    height: 110px;
  }

  @media screen and (min-width: 960px) {
    height: 130px;
  }

  .v-card__title {
    text-transform: lowercase;
    font-weight:900!important;
    font-family:'muli', sans-serif!important;
    padding-top: 10px;
  }
}

.homepage__header {
  align-items: flex-start;
  max-width: 400px;
  margin: 0 auto;

  .col-4, .col-8 {
    margin: 0;
  }

  .arrow {
    margin-top: 5px;
  }

  @media screen and (min-width: 960px) {
    max-width: 600px;
  }
}

.download-the-app {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2;
  background: #e9e8e6;
  position: relative;
  bottom: -40px;

  p {
    font-size: 20px;
    font-weight: bold;
    width: 190px;
    text-align: center;
  }

  &__icons {
    justify-content: center;
    align-items: center;

    .col-4 {
      padding: 0;

      a:focus {
        div[role="img"] {
          outline: $red solid 3px;
        }
      }
    }

    div[role="img"] {
      height: 40px;
    }
  }
}

::v-deep {
  .v-step {
    max-width: 280px !important;
  }

  .v-step__header {
    border-bottom: 3px solid $secondary;
    font-size: 1.125rem;
  }

  .v-step__button {
    border: 0.05rem solid $secondary !important;

    &:focus {
      outline: 2px solid $secondary;
      outline-offset: 2px;
    }
  }
}
</style>